<template>
  <article class="note-panel" :class="{ 'note-panel--readonly': readonly }">
    <div class="note-panel__header">
      <div>
        <h2>{{ title }}</h2>
        <p>{{ subtitle }}</p>
      </div>
      <v-progress-circular
        v-if="saving"
        indeterminate
        size="18"
        width="2"
        color="#8b6d32"
      ></v-progress-circular>
      <v-icon v-else :color="readonly ? '#8b6d32' : '#6f8063'">
        {{ readonly ? 'mdi-lock-outline' : 'mdi-pencil-outline' }}
      </v-icon>
    </div>

    <v-textarea
      :value="value"
      outlined
      no-resize
      hide-details
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
      class="note-panel__textarea"
      rows="10"
      @input="$emit('input', $event)"
    ></v-textarea>
  </article>
</template>

<script>
export default {
  name: 'BibleNotePanel',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.note-panel {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid rgba(97, 112, 89, 0.18);
  background: #fffdf8;
  box-shadow: 0 10px 26px rgba(71, 59, 42, 0.06);
}

.note-panel--readonly {
  background: #fbf7ee;
}

.note-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.note-panel h2 {
  margin: 0;
  color: #433b32;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0;
}

.note-panel p {
  margin: 3px 0 0;
  color: #817769;
  font-size: 0.82rem;
}

.note-panel__textarea ::v-deep textarea {
  line-height: 1.65;
  color: #453e36;
}

.note-panel__textarea ::v-deep .v-input__slot {
  min-height: 230px;
  background: rgba(255, 255, 255, 0.68) !important;
  border-radius: 8px;
}
</style>
